export default __webpack_public_path__ + "static/media/welcome_illustration.cd84d2be.svg";